// extracted by mini-css-extract-plugin
module.exports = {"card":"card-B9M1E"};